module.exports = __webpack_public_path__ + "static/img/image-1.10a70272.png";